import React, { useEffect, useState } from 'react';
import styles from './AdminCitySingle.module.scss';
import AdminSinglePage from '../AdminSinglePage/AdminSinglePage';
import { citySingle } from '../../../redux/actions/app/citySingle';
import { resetCityEdit, resetCitySingle } from '../../../redux/slices/app.slice';
import { useDispatch } from 'react-redux';
import { cityEdit } from '../../../redux/actions/app/cityEdit';
import { useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loading from '../../../components/admin/Loading/Loading';

const AdminCitySingle = () => {
  const [fields, setFields] = useState([]);
  const onFormatData = ({ city: { name, citizenshipId }, countryList }) => {
    setFields([
      [
        {
          label: 'Название',
          type: 'text',
          name: 'name',
        },
        { name: 'citizenshipId', label: 'Страна', type: 'select', options: countryList?.map((country) => ({ value: country?.id, label: country?.name })) },
      ],
    ]);

    return { name, citizenshipId };
  };
  const deleteProps = { successText: 'Пользователь удален', confirmTitle: `Вы уверены что хотите удалить пользователя`, status: 'DELETED' };
  const blockProps = { successText: 'Пользователь заблокирован', confirmTitle: `Вы уверены что хотите заблокировать пользователя`, status: 'BLOCKED' };
  const unblockProps = { successText: 'Пользователь разблокирован', confirmTitle: `Вы уверены что хотите разблокировать пользователя`, status: 'ACTIVE' };
  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    cityEdit: { data: cityEditData, loading: cityEditLoading },
  } = useSelector((state) => state.app);
  const navigate = useNavigate();
  useEffect(() => {
    if (cityEditData) {
      toast.success('Город обновлен');
      navigate('/admin/city/list');
      dispatch(resetCityEdit());
    }
  }, [cityEditData]);

  return (
    <>
      <AdminSinglePage
        isBlock={false}
        isDelete={false}
        onSubmit={(data) => {
          console.log(data);

          dispatch(cityEdit({ id, ...data }));
        }}
        reset={resetCitySingle}
        fetch={citySingle}
        sliceName={'app'}
        actionName={'citySingle'}
        onFormatData={onFormatData}
        fields={fields}
        isSave
        pathList="/admin/city/list"
        deleteProps={deleteProps}
        blockProps={blockProps}
        unblockProps={unblockProps}
        propName={'city'}
        type={'USER'}
      />
      {cityEditLoading && <Loading />}
    </>
  );
};

export default AdminCitySingle;
